import { useEffect, useState } from 'react';
import useGlobalTyping from './useGlobalTyping';
import NameViz from './NameViz';
import _ from 'lodash';
import dataFr from "./assets/dataLightFr.json"
import dataUs from "./assets/dataLightUs.json"
import Settings from './Settings/Settings';

let waitingTimeout;

const namesFr = _(dataFr)
  .map((d, i) => ({ ...d, rank: i }))
  .keyBy('n')
  .value();

const namesUs = _(dataUs)
  .map((d, i) => ({ ...d, rank: i, country: "us" }))
  .keyBy('n')
  .value();

function NameDisplay() {
  const [color, setColor] = useState({ id: 1, back: "dodgerblue", font: "white"})
  const [country, setCountry] = useState(navigator.language === "fr" ? "fr" : "us")
  const [showStats, setShowStats] = useState(true)
  const [nameInfo, setNameInfo] = useState(null)
  const [waiting, setWaiting] = useState(false)
  const [height, setHeight] = useState("100vh")
  const { text, dirty, hiddenInputRef } = useGlobalTyping();

  useEffect(() => {
    clearTimeout(waitingTimeout)
    const nameUC = (text || "").toUpperCase().replaceAll(/\s/g,'').replaceAll("\n", "").replaceAll("\t", "")
    const name = country === "fr" ? namesFr[nameUC] : namesUs[nameUC]
    if(name) {
      setNameInfo({
        name: name.n,
        heights: name.h,
        trends: name.t.map((count, i) => ({ year: name.y + i, count })),
      })
      setWaiting(false)
    } else {
      setNameInfo(null)
      setWaiting(true)
      waitingTimeout = setTimeout(() => setWaiting(false), 3000)
    }
  }, [text, country]);

  useEffect(() => {
    setHeight(window.visualViewport.height)
    window.addEventListener("resize", () => {
      setHeight(window.visualViewport.height)
    })
    return () => {
      window.removeEventListener("resize", setHeight(500));
    };
  }, []);

  return (
    <div>
      <div id="fullView" style={{ backgroundColor: color.back, width: "100%", height: "100vh", color: color.font }}>
        <div className='centered'>
          <NameViz text={text.replaceAll(" ", "").replaceAll("\n", "")} dirty={dirty} data={nameInfo} color={color} country={country} showStats={showStats} backgroundColor={color.back}/>
        </div>
        {!nameInfo && !waiting && text.replaceAll(" ", "").replaceAll("\n", "") !== "" && <div className='centered' style={{ paddingTop: "-5vw" }}> No matching name for {country === "fr" ? "France" : "USA"}, type something else...</div>}
        
        <div
          contentEditable
          ref={hiddenInputRef}
          style={{
            position: 'absolute',
            opacity: 0,
            pointerEvents: 'none',
            zIndex: -1,
          }}
          aria-hidden="true"
        />
      </div>
      <Settings color={color} setColor={setColor} showStats={showStats} setShowStats={setShowStats} country={country} setCountry={setCountry} name={nameInfo?.name} />
    </div>
  );
}

export default NameDisplay;
